import { GenericStateThreeBlockCombinedProps } from './types';

const usePresenter = (props: GenericStateThreeBlockCombinedProps): GenericStateThreeBlockCombinedProps => {
  return props;
};

export default usePresenter;
